/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Noncustomer_SubtitleInputs */

const en_home_noncustomer_subtitle = /** @type {(inputs: Home_Noncustomer_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a personalized quote in minutes — or speak with a licensed advisor.`)
};

const fr_home_noncustomer_subtitle = /** @type {(inputs: Home_Noncustomer_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez un devis personnalisé en quelques minutes — ou parlez à un conseiller agréé.`)
};

/**
* | output |
* | --- |
* | "Get a personalized quote in minutes — or speak with a licensed advisor." |
*
* @param {Home_Noncustomer_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_noncustomer_subtitle = /** @type {((inputs?: Home_Noncustomer_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Noncustomer_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_noncustomer_subtitle(inputs)
	return fr_home_noncustomer_subtitle(inputs)
});